import { render } from "./Photos.vue?vue&type=template&id=6790640a&scoped=true"
const script = {}

import "./Photos.vue?vue&type=style&index=0&id=6790640a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6790640a"

export default script